import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { SiteService } from '../../../services/site/site.service';
import { MapMarker } from '../../../interface/map-marker';
import { environment } from "../../../../../environments/environment"

@Component({
  selector: 'site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.scss']
})
export class SiteMapComponent implements OnInit {
  @Input('graphData') graphData: any;
  @Output()
  onSiteResponse : EventEmitter<{ response : any, widgetId :'' }> = new EventEmitter<{ response:any,widgetId:''}>();
  staticMapImage : any;
  mapCoordinates:any;
  lat: number = 25.2048493;
  lng: number = 55.270782800000006;
  markers: MapMarker[] = [{
    _id: '',
    siteName: '',
    lat: 0,
    lng: 0
  }];
  
  
  constructor(private commonService: CommonService, private siteService: SiteService) { }


  ngOnInit() {
    //get the site lat long
    this.siteService.list("fields=siteName,lat,lng").subscribe(res => {
      this.markers = <MapMarker[]><any>res;
      if(this.markers.length > 0 && this.markers[0].lat && this.markers[0].lng){
        this.lat = this.markers[0].lat;
        this.lng = this.markers[0].lng;
        this.mapCoordinates = res;
        this.onSiteResponse.emit({ response : res, widgetId: this.graphData.udf.widgetId});
        this.getGoogleStaticImage();
      }
    });
  }

  getGoogleStaticImage(){
    if(this.mapCoordinates){
      //URL of Google Static Maps.
      var staticMapUrl = environment.googleMapUrl + "staticmap"; //"https://maps.googleapis.com/maps/api/staticmap";
   
      //Set the Google Map Size.
      staticMapUrl += "?size=400x250";
  
      //Set the Google Map Type.
      staticMapUrl += "&maptype=roadmap";
  
      //Key
      staticMapUrl += "&key=" + environment.googleMapAPIKey;
  
  
      //Loop and add Markers.
      this.mapCoordinates.forEach((siteLatLon)=>{
        staticMapUrl += "&markers=color:blue%7Clabel:" + siteLatLon.siteName.charAt(0).toUpperCase() +"%7C" 
                          + siteLatLon.lat + "," + siteLatLon.lng;
      });
  
      this.staticMapImage = staticMapUrl;
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/site-map/site-map.component.ts